//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     CalendarDay
//   Details:    CalendarDay component
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 105066 06/01/20 JC  M01  Added font awesome
// 108238 10/06/20 JC  M02  Re-wrote datetime components
// WI4743 24/02/25 JC  M03JC Handled isWorking day
//-------------------------------------------------------

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
//M02 import Moment from 'react-moment';
import DateTime from './DateTime'; //M02
import { dateTimeTypes } from '../constants/DateTimeTypes'; //M02
//M01 import { Glyphicon } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; //M01

class CalendarDay extends Component {
	constructor(props) {
		super(props);

		this.handleClick = this.handleClick.bind(this);
	}

	handleClick = event => {
		event.preventDefault();
		this.props.onSelected(this.props.requestId, this.props.date);
	}

	render() {
		const glyphLookup = [
			[],
            <FontAwesomeIcon icon="check" />, //M01
            <FontAwesomeIcon icon="clock" />, //M01
            <FontAwesomeIcon icon="check" />, //M01
            <FontAwesomeIcon icon="times" />, //M01
            <FontAwesomeIcon icon="check" />, //M01
            <FontAwesomeIcon icon="clock" />, //M01
            <FontAwesomeIcon icon="check" />, //M01
            <FontAwesomeIcon icon="times" /> //M01
		];

		return (
			<a onClick={this.handleClick}>
				<span className={`date-text ${this.props.isWorking ? "working" : "out-of-month"}`}><DateTime value={this.props.date} dateTimeType={dateTimeTypes.date} disabled={true} disabledFormat="D" /></span> {/*M02 M03JC*/}
				<span className="date-icon">{glyphLookup[this.props.state]}</span>
				{this.props.isInMonth ? [] : <span className="out-of-month" />}
				{this.props.isToday ? <span className="today" /> : []}
			</a>
		);
	}
}

CalendarDay.propTypes = {
	requestId: PropTypes.number,
	date: PropTypes.string.isRequired,
	state: PropTypes.number.isRequired,
	isInMonth: PropTypes.bool.isRequired,
	isToday: PropTypes.bool.isRequired,
	isWorking: PropTypes.bool.isRequired, //M03JC
	onSelected: PropTypes.func
};

export default connect()(CalendarDay);